export const DefaultIPv6: { [key: string]: string } = {
    PLACEHOLDER: "2001:db8::", // RFC3849
    SUBNET: "64",
    CALCULATE: "Calculate",
    VALIDATION_ERROR: "Invalid IPv6 address",
};
